if (!customElements.get('text-marquee')) {
  customElements.define(
    'text-marquee',
    class TextMarquee extends HTMLElement {
      constructor() {
        super();
        this.track = null;
        this.trackHalfWidth = 0;
        this.lastScrollY = window.scrollY;
        this.currentOffset = 0;
        this.onScroll = this.onScroll.bind(this);
        this.onResize = this.onResize.bind(this);
      }

      connectedCallback() {
        this.track = this.querySelector('.text-marquee__track');
        if (!this.track) return;

        this.measure();
        this.bindListeners();
      }

      disconnectedCallback() {
        this.unbindListeners();
      }

      isMobile() {
        return window.innerWidth <= 768;
      }

      usesScrollLinkedMobile() {
        return this.isMobile() && !this.classList.contains('text-marquee--mobile-auto');
      }

      measure() {
        this.trackHalfWidth = this.track.scrollWidth / 2;
      }

      bindListeners() {
        if (this.usesScrollLinkedMobile()) {
          window.addEventListener('scroll', this.onScroll, { passive: true });
        }
        window.addEventListener('resize', this.onResize, { passive: true });
      }

      unbindListeners() {
        window.removeEventListener('scroll', this.onScroll);
        window.removeEventListener('resize', this.onResize);
      }

      onScroll() {
        if (!this.usesScrollLinkedMobile()) return;

        const scrollY = window.scrollY;
        const delta = scrollY - this.lastScrollY;
        this.lastScrollY = scrollY;

        this.currentOffset -= delta * 0.35;

        if (Math.abs(this.currentOffset) >= this.trackHalfWidth) {
          this.currentOffset = this.currentOffset % this.trackHalfWidth;
        }

        this.track.style.setProperty('--marquee-offset', `${this.currentOffset}px`);
      }

      onResize() {
        this.measure();

        if (this.usesScrollLinkedMobile()) {
          window.addEventListener('scroll', this.onScroll, { passive: true });
          this.track.style.animation = 'none';
        } else {
          window.removeEventListener('scroll', this.onScroll);
          this.track.style.removeProperty('--marquee-offset');
          this.track.style.removeProperty('animation');
          this.currentOffset = 0;
        }
      }
    }
  );
}
